// 企业概况
<template>
  <div class="mapwrap" v-if="isRefresh">
    <div>
      <el-tabs class="pollutionSrcsTabs" v-model="tabType" @tab-click="handleRefresh()" stretch>
        <el-tab-pane v-for="(tabDataItem, tabDataIndex) in tabData" :key="tabDataIndex"
          :label="tabDataItem.tabTitle" :name="tabDataItem.tabIndex"></el-tab-pane>
        <!-- <el-tab-pane label="关键环境信息提要-年度主要污染物排放和碳排放)" name="tabAB"></el-tab-pane>
        <el-tab-pane label="关键环境信息提要-生态环境行政处罚、司法判决等)" name="tabAC"></el-tab-pane>
        <el-tab-pane label="企业基本信息" name="first"></el-tab-pane>
        <el-tab-pane label="企业环境管理信息" name="second"></el-tab-pane>
        <el-tab-pane label="污染物产生、治理与排放信息" name="third"></el-tab-pane>
        <el-tab-pane label="碳排放信息" name="fourth"></el-tab-pane>
        <el-tab-pane label="强制性清洁生产审核信息" name="fifth"></el-tab-pane>
        <el-tab-pane label="生态环境应急信息" name="sixth"></el-tab-pane>
        <el-tab-pane label="生态环境违法信息" name="seventh"></el-tab-pane>
        <el-tab-pane label="临时报告情况" name="eighth"></el-tab-pane>
        <el-tab-pane label="相关投融资的生态环保信息" name="ninth"></el-tab-pane> -->
      </el-tabs>
    </div>
    <!-- table -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'table'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="addRow">新增</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" icon="el-icon-refresh-right" @click="handleRefresh">刷新</el-button>
    </div>
    <div class="mainTable" v-if="tabDataCrt.tabType === 'table'">
      <table class="listTable" width="100%" border="1" align="center">
        <tr>
          <th class="cell thtitle" width="4%">序号</th>
          <th class="cell thtitle" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th>
          <th class="cell thtitle" width="12%">操作</th>
        </tr>
        <tr v-for="(tr, tri) in tabDataCrt.tableData" :key="tri">
          <td class="cell tdcell">{{tri+1}}</td>
          <td class="cell tdcell" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tr.editFlag" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
          <td class="cell tdcell">
            <el-button type="text" size="mini" @click="editRow(tr)">编辑</el-button>
            <el-button type="text" size="mini" @click="saveRow(tr)">保存</el-button>
            <el-button type="text" size="mini" @click="deleteRow(tr)">删除</el-button>
            <!-- <el-button type="text" size="mini" @click="makeSure(item)">上传文件</el-button> -->
          </td>
        </tr>
      </table>
    </div>
    <!-- multiform -->
    <div class="searchInput" v-if="tabDataCrt.tabType === 'multiform'">
      <el-button class="btnRefresh" type="primary" size="mini" @click="editForm()">编辑</el-button>
      <el-button class="btnRefresh" type="primary" size="mini" @click="saveForm()">保存</el-button>
    </div>
    <div class="mainTable" v-if="tabDataCrt.tabType === 'multiform'">
      <table class="listTable" width="100%" border="1" align="center">
        <!-- <tr>
          <th class="cell thtitle" width="25%" v-for="(th, thi) in tabDataCrt.tableNames" :key="thi">{{tabDataCrt.tableNames[thi]}}</th>
        </tr> -->
        <tr v-for="(tr, tri) in tabDataCrt.multiformData" :key="tri">
          <td class="cell tdcell" width="25%" v-for="(td, tdi) in tabDataCrt.rowItems" :key="tdi">
            <el-input v-if="tabDataCrt.editable && !tr.editFlag && td !== 'name'" v-model="tr[td]"></el-input>
            <span v-else>{{tr[td]}}</span>
          </td>
        </tr>
      </table>
    </div>
    <!-- other -->
    <div class="bottom-pagination">
      <el-pagination
        hide-on-single-page
        small
        background
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="pages"
        :current-page="pageNo"
        :total="totalNumber">
      </el-pagination>
    </div>
    <!-- <nut-dialog
      @close="importFlag = false"
      v-if="importFlag"
      :visible="importFlag"
      :title="上传文件"
      :noFooter="true">
      <ehsTableImport
        ref="uploadRef"
        :btnName="'上传'"
        :uploadMethod="'hbEffectEnclosureUpload'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'"
        :extaParam="extaParam"
        :fileSize="100"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUpload">
      </ehsTableImport>
    </nut-dialog> -->
    <!-- <nut-dialog
      @close="importFlagA = false"
      v-if="importFlagA"
      :visible="importFlagA"
      title="上传文件"
      :noFooter="true">
      <ehsTableImport
        ref="uploadRefA"
        :btnName="'上传'"
        :uploadMethod="'hbManagementInformationUpload'"
        :acceptList="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/pdf'"
        :extaParam="extaParam"
        :fileSize="100"
        @uploadSuccess="handleSuccess"
        @beforeUpload="checkUploadA">
      </ehsTableImport>
    </nut-dialog> -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import api from '../../../api/index'
// import { ipcRenderer } from 'electron'
// import ehsTableImport from '../ehs-com/ehsTableImport'
export default {
  props: ['reportId'],
  data () {
    return {
      tabType: 'tabAA',
      // showTabs: false,
      // importFlag: false,
      // importFlagA: false,
      // extaParam: {},
      companyName: '',
      picture: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      // needCorrection: '',
      // managementLevel: '',
      // unitName: '',
      // registeredAddress: '',
      // productionAddress: '',
      // postalCode: '',
      // industryLevel: '',
      // otherIndustryLevels: '',
      // whetherProduction: '',
      // productionDate: '',
      // centerLongitude: '',
      // centerDimension: '',
      // organizationCode: '',
      // socialCreditCode: '',
      // legalRepresentative: '',
      // technicalDirector: '',
      // fixedTelephone: '',
      // mobilePhone: '',
      // belongAtmosphere: '',
      // belongTotalPhosphorus: '',
      // belongTotalNitrogen: '',
      // belongMetal: '',
      // industrialPark: '',
      // industrialParkName: '',
      // industrialParkCode: '',
      // approvalDocument: '',
      // filingNo: '',
      // filingDocuments: '',
      // planningDocuments: '',
      // planDocumentNo: '',
      // airPollutantIndex: '',
      // waterPollutantIndex: '',
      // tabData
      tabData: [
        {
          tabTitle: '关键环境信息提要-年度生态环境行政许可变更情况汇总表',
          tabIndex: 'tabAA',
          tabType: 'table',
          tableNames: [
            '变更情况',
            '项目名称',
            '目前进度',
            '审批部门',
            '批复文号',
            '批复日期'
          ],
          rowItems: [
            'changes',
            'entryName',
            'currentProgress',
            'approvalDepartment',
            'approvalNo',
            'approvalDate'
          ],
          api: {
            add: 'hbChangesAdd',
            enquiry: 'hbChangesEnquiry',
            update: 'hbChangesUpdate',
            delete: 'hbChangesDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '关键环境信息提要-年度生态环境行政许可变更情况汇总表',
          tabIndex: 'tabAB',
          tabType: 'table',
          tableNames: [
            '排放口类型',
            '排放口编码',
            '排放口名称',
            '污染物',
            '1季度实际排放量(吨)',
            '2季度实际排放量(吨)',
            '3季度实际排放量(吨)',
            '4季度实际排放量(吨)',
            '年度合计(吨)',
            '备注'
          ],
          rowItems: [
            'dischargeType',
            'dischargeNum',
            'dischargeName',
            'contaminants',
            'firstQuarter',
            'secondQuarter',
            'thirdQuarter',
            'fourthQuarter',
            'total',
            'remarks'
          ],
          api: {
            add: 'hbActualEmissionsAdd',
            enquiry: 'hbActualEmissionsEnquiry',
            update: 'hbActualEmissionsUpdate',
            delete: 'hbActualEmissionsDelete',
            extraParam: {
              // type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '关键环境信息提要-生态环境行政处罚、司法判决等',
          tabIndex: 'tabAC',
          tabType: 'table',
          tableNames: [
            '类别',
            '事由',
            '部门',
            '文号',
            '日期',
            '罚款'
          ],
          rowItems: [
            'category',
            'subjectMatter',
            'department',
            'documentNumber',
            'date',
            'fine'
          ],
          api: {
            add: 'hbChangesAdd',
            enquiry: 'hbChangesEnquiry',
            update: 'hbChangesUpdate',
            delete: 'hbChangesDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '企业基本信息-排污单位基本信息',
          tabIndex: 'tabBA',
          tabType: 'multiform',
          tableNames: [
            '名称',
            '内容',
            '执行情况(是/否)',
            '备注'
          ],
          rowItems: [
            'name',
            'content',
            'implementation',
            'reason'
          ],
          editable: false,
          multiformData: [
            {
              name: '名称',
              content: '内容',
              editFlag: 3,
              options: [{}],
              implementation: '执行情况(是/否)',
              reason: '备注'
            }, {
              name: '单位名称：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '注册地址：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '邮政编码：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              remarks: '',
              implementation: '',
              reason: ''
            }, {
              name: '生产经营场所地址：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '行业类别：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '生产经营场所中心经度：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '生产经营场所中心纬度：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '组织机构代码：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '统一社会信用代码：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '技术负责人：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '联系电话：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }
          ]
        },
        {
          tabTitle: '企业基本信息-企业属性',
          tabIndex: 'tabBB',
          tabType: 'multiform',
          tableNames: [
            '名称',
            '内容',
            '执行情况(是/否)',
            '备注'
          ],
          rowItems: [
            'name',
            'content',
            'implementation',
            'reason'
          ],
          editable: false,
          multiformData: [
            {
              name: '名称',
              content: '内容',
              editFlag: 3,
              options: [{}],
              implementation: '执行情况(是/否)',
              reason: '备注'
            }, {
              name: '企业性质：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '是否属于重点排污单位：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }, {
              name: '是否属于实施强制性清洁生产审核的企业：',
              content: '',
              editFlag: 0,
              editFlagA: 1,
              implementation: '',
              reason: ''
            }
          ]
        },
        {
          tabTitle: '企业基本信息-主要产品及服务',
          tabIndex: 'tabBC',
          tabType: 'table',
          tableNames: [
            '名称',
            '内容',
            '执行情况',
            '备注'
          ],
          rowItems: [
            'name',
            'content',
            'implementation',
            'remarks'
          ],
          api: {
            add: 'hbProductsServicesAdd',
            enquiry: 'hbProductsServicesEnquiry',
            update: 'hbProductsServicesUpdate',
            delete: 'hbProductsServicesDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '企业基本信息-主要生产工艺名称',
          tabIndex: 'tabBD',
          tabType: 'table',
          tableNames: [
            '名称',
            '内容',
            '执行情况',
            '备注'
          ],
          rowItems: [
            'name',
            'content',
            'implementation',
            'remarks'
          ],
          api: {
            add: 'hbProductsServicesAdd',
            enquiry: 'hbProductsServicesEnquiry',
            update: 'hbProductsServicesUpdate',
            delete: 'hbProductsServicesDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '企业环境管理信息-生态环境行政许可信息',
          tabIndex: 'tabCA',
          tabType: 'table',
          tableNames: [
            '许可名称',
            '编号',
            '审批文件',
            '核发机关',
            '获取时间',
            '有效期限',
            '主要许可事项'
          ],
          rowItems: [
            'licenseName',
            'number',
            'approvalDocuments',
            'issuingAuthority',
            'getTime',
            'validityTerm',
            'mainLicensing'
          ],
          api: {
            add: 'hbLicensingAdd',
            enquiry: 'hbLicensingEnquiry',
            update: 'hbLicensingUpdate',
            delete: 'hbLicensingDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '企业环境管理信息-环境保护税缴纳信息',
          tabIndex: 'tabCB',
          tabType: 'table',
          tableNames: [
            '税目',
            '污染物',
            '缴纳额',
            '实际缴纳额',
            '减免情况',
            '备注'
          ],
          rowItems: [
            'taxItem',
            'contaminants',
            'paymentAmount',
            'actualPayment',
            'relief',
            'remarks'
          ],
          api: {
            add: 'hbLicensingAdd',
            enquiry: 'hbLicensingEnquiry',
            update: 'hbLicensingUpdate',
            delete: 'hbLicensingDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '企业环境管理信息-投保环境污染责任保险信息',
          tabIndex: 'tabCC',
          tabType: 'table',
          tableNames: [
            '类型',
            '投保保额',
            '是否当年新增投保',
            '投保时间',
            '投保截止日期',
            '承保公司',
            '备注'
          ],
          rowItems: [
            'category',
            'insuredAmount',
            'newInsurance',
            'insuranceTime',
            'date',
            'insuranceCarriers',
            'remarksA'
          ],
          api: {
            add: 'hbEvaluationAdd',
            enquiry: 'hbEvaluationEnquiry',
            update: 'hbEvaluationUpdate',
            delete: 'hbEvaluationDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '企业环境管理信息-环保信用评价等级',
          tabIndex: 'tabCD',
          tabType: 'table',
          tableNames: [
            '类型',
            '评价机构',
            '前一年等级',
            '当年等级',
            '变化原因',
            '备注'
          ],
          rowItems: [
            'category',
            'evaluationOrganization',
            'beforeGrade',
            'onGrade',
            'changeReason',
            'remarksA'
          ],
          api: {
            add: 'hbEvaluationAdd',
            enquiry: 'hbEvaluationEnquiry',
            update: 'hbEvaluationUpdate',
            delete: 'hbEvaluationDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-污染防治设施信息-污染防治设施正常运行信息表',
          tabIndex: 'tabDAA',
          tabType: 'table',
          tableNames: [
            '设施名称',
            '产污环节',
            '处理的污染物',
            '排放口名称',
            '排放口编号',
            '第三方运维单位-名称',
            '第三方运维单位-联系人',
            '第三方运维单位-联系方式'
          ],
          rowItems: [
            'facilityName',
            'pollutionProdLink',
            'handleContaminants',
            'dischargeName',
            'dischargeNum',
            'name',
            'contacts',
            'contact'
          ],
          api: {
            add: 'hbPreventionAdd',
            enquiry: 'hbPreventionEnquiry',
            update: 'hbPreventionUpdate',
            delete: 'hbPreventionDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-污染防治设施信息-污染防治设施非正常运行信息',
          tabIndex: 'tabDAB',
          tabType: 'table',
          tableNames: [
            '设施名称',
            '处理的污染物',
            '次数',
            '日期',
            '时长',
            '主要原因',
            '应对措施'
          ],
          rowItems: [
            'facilityName',
            'handleContaminants',
            'frequency',
            'date',
            'duration',
            'reason',
            'countermeasures'
          ],
          api: {
            add: 'hbPreventionAdd',
            enquiry: 'hbPreventionEnquiry',
            update: 'hbPreventionUpdate',
            delete: 'hbPreventionDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-主要水污染物、大气污染物排放相关信息-水污染物和有组织大气污染物排放相关信息',
          tabIndex: 'tabDBA',
          tabType: 'table',
          tableNames: [
            '排放口类型',
            '排放口编号',
            '排放口名称',
            '污染物',
            '实际排放总量',
            '排放浓度年均值（大气/小时、水/日均）',
            '是否安装在线监测设备',
            '在线监测设备名称和型号',
            '是否与环境部门联网'
          ],
          rowItems: [
            'dischOutletType',
            'dischOutletNum',
            'dischOutletName',
            'contaminants',
            'totalEmission',
            'emissionConcent',
            'isInstalled',
            'onlineMonitoring',
            'isNetworking'
          ],
          api: {
            add: 'hbPollutantEmissionAdd',
            enquiry: 'hbPollutantEmissionEnquiry',
            update: 'hbPollutantEmissionUpdate',
            delete: 'hbPollutantEmissionDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-主要水污染物、大气污染物排放相关信息-无组织大气污染物排放相关信息',
          tabIndex: 'tabDBB',
          tabType: 'table',
          tableNames: [
            '监测点位名称',
            '污染物',
            '实际排放总量',
            '实际排放浓度'
          ],
          rowItems: [
            'pointsName',
            'contaminants',
            'totalEmission',
            'actualConcentration'
          ],
          api: {
            add: 'hbPollutantEmissionAdd',
            enquiry: 'hbPollutantEmissionEnquiry',
            update: 'hbPollutantEmissionUpdate',
            delete: 'hbPollutantEmissionDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-主要水污染物、大气污染物排放相关信息-自行监测相关信息',
          tabIndex: 'tabDBC',
          tabType: 'table',
          tableNames: [
            '全年生产天数',
            '排放口名称',
            '污染物',
            '自行监测天数（次数）',
            '达标次数',
            '超标次数',
            '名称',
            '资质'
          ],
          rowItems: [
            'productionDays',
            'dischOutletName',
            'contaminants',
            'monitoringDays',
            'completeFrequency',
            'exceedFrequency',
            'name',
            'qualifications'
          ],
          api: {
            add: 'hbRelevantAdd',
            enquiry: 'hbRelevantEnquiry',
            update: 'hbRelevantUpdate',
            delete: 'hbRelevantDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-工业固体废物的产生、贮存、流向和利用处置信息-固体废物信息表',
          tabIndex: 'tabDCA',
          tabType: 'table',
          tableNames: [
            '名称',
            '种类',
            '成分',
            '等级',
            '产生量',
            '贮存量',
            '利用处置方式',
            '利用处置量'
          ],
          rowItems: [
            'name',
            'kind',
            'component',
            'grade',
            'production',
            'storageCapacity',
            'disposalMethods',
            'disposalVolume'
          ],
          api: {
            add: 'hbRelevantAdd',
            enquiry: 'hbRelevantEnquiry',
            update: 'hbRelevantUpdate',
            delete: 'hbRelevantDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-工业固体废物的产生、贮存、流向和利用处置信息-一般工业固体废物贮存或自行利用处置信息表',
          tabIndex: 'tabDCB',
          tabType: 'table',
          tableNames: [
            '贮存-场所或设施的类型',
            '贮存-面积',
            '贮存-累计贮存量',
            '贮存-经纬度坐标',
            '自行利用处置-利用处置方式',
            '自行利用处置-利用处置场所或设施的类型',
            '自行利用处置-面积',
            '自行利用处置-累计利用处置量',
            '自行利用处置-经纬度坐标'
          ],
          rowItems: [
            'placeType',
            'area',
            'cumulativeStock',
            'coordinate',
            'disposalMethod',
            'manPlaceType',
            'areaA',
            'totalDisVolume',
            'coordinateA'
          ],
          api: {
            add: 'hbWasteStorageAdd',
            enquiry: 'hbWasteStorageEnquiry',
            update: 'hbWasteStorageUpdate',
            delete: 'hbWasteStorageDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-工业固体废物的产生、贮存、流向和利用处置信息-一般工业固体废物委外利用处置信息表',
          tabIndex: 'tabDCC',
          tabType: 'table',
          tableNames: [
            '名称',
            '利用处置方式',
            '受托方名称',
            '资格',
            '技术能力',
            '运输',
            '累计利用处置量'
          ],
          rowItems: [
            'name',
            'disposalMethod',
            'trusteeName',
            'qualifications',
            'technicalCapability',
            'transport',
            'totalDisVolume'
          ],
          api: {
            add: 'hbWasteStorageAdd',
            enquiry: 'hbWasteStorageEnquiry',
            update: 'hbWasteStorageUpdate',
            delete: 'hbWasteStorageDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-工业固体废物的产生、贮存、流向和利用处置信息-危险废物信息表',
          tabIndex: 'tabDCD',
          tabType: 'table',
          tableNames: [
            '名称',
            '废物代码',
            '成分',
            '有害成分',
            '产生量',
            '贮存量',
            '方式',
            '数量',
            '累计贮存量'
          ],
          rowItems: [
            'name',
            'wasteCode',
            'component',
            'harmfulIngredients',
            'production',
            'storageCapacity',
            'mode',
            'quantity',
            'totalStorageCapacity'
          ],
          api: {
            add: 'hbHazardousAdd',
            enquiry: 'hbHazardousEnquiry',
            update: 'hbHazardousUpdate',
            delete: 'hbHazardousDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-工业固体废物的产生、贮存、流向和利用处置信息-危险废物贮存或自行利用处置信息表',
          tabIndex: 'tabDCE',
          tabType: 'table',
          tableNames: [
            '名称',
            '场所或设施的类型',
            '面积',
            '累计贮存量',
            '经纬度坐标',
            '自行利用处置-利用处置方式',
            '自行利用处置-利用处置场所或设施的类型',
            '自行利用处置-面积',
            '自行利用处置-经纬度坐标'
          ],
          rowItems: [
            'name',
            'placeType',
            'area',
            'cumulativeStock',
            'coordinate',
            'disposalMethod',
            'manPlaceType',
            'areaA',
            'coordinateA'
          ],
          api: {
            add: 'hbWasteStorageAdd',
            enquiry: 'hbWasteStorageEnquiry',
            update: 'hbWasteStorageUpdate',
            delete: 'hbWasteStorageDelete',
            extraParam: {
              type: 3
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-工业固体废物的产生、贮存、流向和利用处置信息-危险废物委外利用处置信息表',
          tabIndex: 'tabDCF',
          tabType: 'table',
          tableNames: [
            '名称',
            '利用处置方式',
            '受托方名称',
            '资格',
            '运输',
            '累计利用处置量',
            '危险废物转移联单'
          ],
          rowItems: [
            'name',
            'disposalMethod',
            'trusteeName',
            'qualifications',
            'transport',
            'totalDisVolume',
            'transferSheet'
          ],
          api: {
            add: 'hbWasteStorageAdd',
            enquiry: 'hbWasteStorageEnquiry',
            update: 'hbWasteStorageUpdate',
            delete: 'hbWasteStorageDelete',
            extraParam: {
              type: 4
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-排放的有毒有害物质信息',
          tabIndex: 'tabDD',
          tabType: 'table',
          tableNames: [
            '排放口编号',
            '排放口名称',
            '名称',
            '形态',
            '毒性',
            '排放浓度',
            '排放总量'
          ],
          rowItems: [
            'disQutletNum',
            'disOutletName',
            'name',
            'form',
            'toxicity',
            'emissionConcent',
            'totalEmission'
          ],
          api: {
            add: 'hbHazardousAdd',
            enquiry: 'hbHazardousEnquiry',
            update: 'hbHazardousUpdate',
            delete: 'hbHazardousDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-噪声排放信息',
          tabIndex: 'tabDE',
          tabType: 'table',
          tableNames: [
            '点位编号',
            '点位名称',
            '位置',
            '执行标准',
            '排放限值',
            '实际排放值'
          ],
          rowItems: [
            'pointNum',
            'pointName',
            'position',
            'executiveStandard',
            'emissionLimits',
            'actualEmissionValue'
          ],
          api: {
            add: 'hbInformationAdd',
            enquiry: 'hbInformationEnquiry',
            update: 'hbInformationUpdate',
            delete: 'hbInformationDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-施工扬尘信息',
          tabIndex: 'tabDF',
          tabType: 'table',
          tableNames: [
            '点位编号',
            '点位名称',
            '位置',
            '防治措施'
          ],
          rowItems: [
            'pointNum',
            'pointName',
            'position',
            'preventionCure'
          ],
          api: {
            add: 'hbInformationAdd',
            enquiry: 'hbInformationEnquiry',
            update: 'hbInformationUpdate',
            delete: 'hbInformationDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '污染物信息-排污许可管理信息',
          tabIndex: 'tabDG',
          tabType: 'table',
          tableNames: [
            '执行报告类型',
            '应公开次数',
            '实际公开次数',
            '公开的网址'
          ],
          rowItems: [
            'reportType',
            'publicTimes',
            'actualPublicTimes',
            'website'
          ],
          api: {
            add: 'hbInformationAdd',
            enquiry: 'hbInformationEnquiry',
            update: 'hbInformationUpdate',
            delete: 'hbInformationDelete',
            extraParam: {
              type: 3
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '碳排放信息-碳排放信息表',
          tabIndex: 'tabEA',
          tabType: 'table',
          tableNames: [
            '排放设施',
            '核算方法',
            '年度碳实际排放量',
            '上一年度实际排放量'
          ],
          rowItems: [
            'dischargeFacilities',
            'accountingMethod',
            'actualAnnual',
            'lastYear'
          ],
          api: {
            add: 'hbDisclosureAdd',
            enquiry: 'hbDisclosureEnquiry',
            update: 'hbDisclosureUpdate',
            delete: 'hbDisclosureDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '强制性清洁生产审核信息-信息披露情况报表',
          tabIndex: 'tabFA',
          tabType: 'table',
          tableNames: [
            '实施强制性清洁生产审核的原因',
            '审核咨询公司',
            '审核时间',
            '评估情况',
            '验收情况'
          ],
          rowItems: [
            'auditReasons',
            'auditConsulting',
            'auditTime',
            'assessment',
            'acceptance'
          ],
          api: {
            add: 'hbDisclosureAdd',
            enquiry: 'hbDisclosureEnquiry',
            update: 'hbDisclosureUpdate',
            delete: 'hbDisclosureDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '生态环境应急信息-生态环境应急信息表',
          tabIndex: 'tabGA',
          tabType: 'table',
          tableNames: [
            '应急预案-名称',
            '应急预案-备案机关',
            '应急预案-备案编号',
            '现有生态环境应急资源',
            '突发环境事件-发生时间',
            '突发环境事件-发生原因',
            '突发环境事件-处置情况'
          ],
          rowItems: [
            'name',
            'filingAuthority',
            'filingNo',
            'emergencyResources',
            'occurrenceTime',
            'occurrenceCause',
            'disposal'
          ],
          api: {
            add: 'hbEmergencyAdd',
            enquiry: 'hbEmergencyEnquiry',
            update: 'hbEmergencyUpdate',
            delete: 'hbEmergencyDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '生态环境应急信息-重污染天气应急响应信息表',
          tabIndex: 'tabGB',
          tabType: 'table',
          tableNames: [
            '响应时段',
            '预警等级',
            '绩效分级结果',
            '预警措施要求',
            '措施实际执行情况'
          ],
          rowItems: [
            'responsePeriod',
            'warningLevel',
            'gradingResults',
            'warningMeasures',
            'implementation'
          ],
          api: {
            add: 'hbEmergencyAdd',
            enquiry: 'hbEmergencyEnquiry',
            update: 'hbEmergencyUpdate',
            delete: 'hbEmergencyDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '生态环境违法信息-生态环境行政处罚信息表',
          tabIndex: 'tabHA',
          tabType: 'table',
          tableNames: [
            '行政处罚决定书-下达时间',
            '行政处罚决定书-处罚部门',
            '行政处罚决定书-文号',
            '行政处罚决定书-原文',
            '处罚事由',
            '整改事项-整改完成时间',
            '整改事项-整改措施'
          ],
          rowItems: [
            'releaseTime',
            'punishmentDepartment',
            'documentNumber',
            'originalText',
            'punishmentReasons',
            'completionTime',
            'rectificationMeasures'
          ],
          api: {
            add: 'hbIllegalInformationAdd',
            enquiry: 'hbIllegalInformationEnquiry',
            update: 'hbIllegalInformationUpdate',
            delete: 'hbIllegalInformationDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '生态环境违法信息-生态环境司法判决信息表',
          tabIndex: 'tabHB',
          tabType: 'table',
          tableNames: [
            '判决书-下达时间',
            '判决书-判决机关',
            '判决书-文号',
            '判决书-原文',
            '判决事由',
            '整改事项-整改完成时间',
            '整改事项-整改措施'
          ],
          rowItems: [
            'responsePeriod',
            'judgmentOrgan',
            'documentNumber',
            'originalText',
            'judgmentCause',
            'completionTime',
            'rectificationMeasures'
          ],
          api: {
            add: 'hbIllegalInformationAdd',
            enquiry: 'hbIllegalInformationEnquiry',
            update: 'hbIllegalInformationUpdate',
            delete: 'hbIllegalInformationDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '临时报告情况',
          tabIndex: 'tabIA',
          tabType: 'table',
          tableNames: [
            '报告名称',
            '报告时间',
            '报告事由',
            '主要情况'
          ],
          rowItems: [
            'reportName',
            'reportTime',
            'reportReason',
            'mainSituation'
          ],
          api: {
            add: 'hbReportingSituationAdd',
            enquiry: 'hbReportingSituationEnquiry',
            update: 'hbReportingSituationUpdate',
            delete: 'hbReportingSituationDelete',
            extraParam: {
              type: 1
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        },
        {
          tabTitle: '相关投融资的生态环保信息',
          tabIndex: 'tabJA',
          tabType: 'table',
          tableNames: [
            '融资形式',
            '金额',
            '投向',
            '应对气候变化的措施',
            '生态环境保护措施'
          ],
          rowItems: [
            'financingForm',
            'amount',
            'turnTo',
            'climateChange',
            'ecological'
          ],
          api: {
            add: 'hbReportingSituationAdd',
            enquiry: 'hbReportingSituationEnquiry',
            update: 'hbReportingSituationUpdate',
            delete: 'hbReportingSituationDelete',
            extraParam: {
              type: 2
            }
          },
          tableData: [{
            id: 0,
            editFlag: false
          }]
        }
        // table模板
        // ,
        // {
        //   tabTitle: '标题',
        //   tabIndex: 'tabAA',
        //   tabType: 'table',
        //   tableNames: [
        //     '表头1',
        //     '表头2',
        //     '表头3',
        //     '表头4',
        //     '表头5',
        //     '表头6',
        //     '表头7',
        //     '表头8',
        //     '表头9'
        //   ],
        //   rowItems: [
        //     'item1',
        //     'item2',
        //     'item3',
        //     'item4',
        //     'item5',
        //     'item6',
        //     'item7',
        //     'item8',
        //     'item9'
        //   ],
        //   api: {
        //     add: 'xxxAdd',
        //     enquiry: 'xxxEnquiry',
        //     update: 'xxxUpdate',
        //     delete: 'xxxDelete',
        //     extraParam: {}
        //   },
        //   tableData: [{
        //     id: 0,
        //     editFlag: false
        //   }]
        // }
        // multiform模板,
        // {
        //   tabTitle: '标题',
        //   tabIndex: 'tabBA',
        //   tabType: 'multiform',
        //   tableNames: [
        //     '名称',
        //     '内容',
        //     '执行情况(是/否)',
        //     '备注'
        //   ],
        //   rowItems: [
        //     'name',
        //     'content',
        //     'implementation',
        //     'reason'
        //   ],
        //   editable: false,
        //   multiformData: [
        //     {
        //       name: '名称',
        //       content: '内容',
        //       editFlag: 3,
        //       options: [{}],
        //       implementation: '执行情况(是/否)',
        //       reason: '备注'
        //     }, {
        //       name: '企业性质：',
        //       content: '',
        //       editFlag: 0,
        //       editFlagA: 1,
        //       implementation: '',
        //       reason: ''
        //     }, {
        //       name: '是否属于重点排污单位：',
        //       content: '',
        //       editFlag: 0,
        //       editFlagA: 1,
        //       implementation: '',
        //       reason: ''
        //     }, {
        //       name: '是否属于实施强制性清洁生产审核的企业：',
        //       content: '',
        //       editFlag: 0,
        //       editFlagA: 1,
        //       implementation: '',
        //       reason: ''
        //     }
        //   ]
        // }
      ],
      tabDataCrt: {},
      pages: 10,
      pageNo: 1,
      totalNumber: 1,
      isRefresh: true
    }
  },
  mounted () {
    this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
    this.getTabData()
  },
  methods: {
    getTabData (pageNo = 1) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.enquiry]({
          pageNo: pageNo,
          pages: 10,
          reportId: this.reportId,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.totalNumber = res.data.totalNumber
          var tempArr = []
          res.data.list.forEach(item => {
            var arrPusher = {
              id: item.id,
              editFlag: false
            }
            this.tabDataCrt.rowItems.forEach(rowItem => {
              arrPusher[rowItem] = item[rowItem] || ''
            })
            tempArr.push(arrPusher)
          })
          this.tabDataCrt.tableData = tempArr
          console.log(this.tabDataCrt.tableData)
        })
      } else if (this.tabDataCrt.tabType === 'multiform') {
        if (this.tabType === 'tabBA') {
          api.HbEnterpriseSituationEnquiry({
            reportId: this.reportId
          }).then(res => {
            if (res.data) {
              this.tabDataCrt.multiformData[1].implementation = res.data.changeOne
              this.tabDataCrt.multiformData[1].reason = res.data.remarksOne
              this.tabDataCrt.multiformData[2].implementation = res.data.changeTwo
              this.tabDataCrt.multiformData[2].reason = res.data.remarksTwo
              this.tabDataCrt.multiformData[3].implementation = res.data.changeThree
              this.tabDataCrt.multiformData[3].reason = res.data.remarksThree
              this.tabDataCrt.multiformData[4].implementation = res.data.changeFour
              this.tabDataCrt.multiformData[4].reason = res.data.remarksFour
              this.tabDataCrt.multiformData[5].implementation = res.data.changeFive
              this.tabDataCrt.multiformData[5].reason = res.data.remarksFive
              this.tabDataCrt.multiformData[6].implementation = res.data.changeSix
              this.tabDataCrt.multiformData[6].reason = res.data.remarksSix
              this.tabDataCrt.multiformData[7].implementation = res.data.changeSeven
              this.tabDataCrt.multiformData[7].reason = res.data.remarksSeven
              this.tabDataCrt.multiformData[8].implementation = res.data.changeEight
              this.tabDataCrt.multiformData[8].reason = res.data.remarksEight
              this.tabDataCrt.multiformData[9].implementation = res.data.changeNine
              this.tabDataCrt.multiformData[9].reason = res.data.remarksNine
              this.tabDataCrt.multiformData[10].implementation = res.data.changeTen
              this.tabDataCrt.multiformData[10].reason = res.data.remarksTen
              this.tabDataCrt.multiformData[11].implementation = res.data.changeEleven
              this.tabDataCrt.multiformData[11].reason = res.data.remarksEleven
            } else {
              this.tabDataCrt.multiformData[1].implementation = ''
              this.tabDataCrt.multiformData[1].reason = ''
              this.tabDataCrt.multiformData[2].implementation = ''
              this.tabDataCrt.multiformData[2].reason = ''
              this.tabDataCrt.multiformData[3].implementation = ''
              this.tabDataCrt.multiformData[3].reason = ''
              this.tabDataCrt.multiformData[4].implementation = ''
              this.tabDataCrt.multiformData[4].reason = ''
              this.tabDataCrt.multiformData[5].implementation = ''
              this.tabDataCrt.multiformData[5].reason = ''
              this.tabDataCrt.multiformData[6].implementation = ''
              this.tabDataCrt.multiformData[6].reason = ''
              this.tabDataCrt.multiformData[7].implementation = ''
              this.tabDataCrt.multiformData[7].reason = ''
              this.tabDataCrt.multiformData[8].implementation = ''
              this.tabDataCrt.multiformData[8].reason = ''
              this.tabDataCrt.multiformData[9].implementation = ''
              this.tabDataCrt.multiformData[9].reason = ''
              this.tabDataCrt.multiformData[10].implementation = ''
              this.tabDataCrt.multiformData[10].reason = ''
              this.tabDataCrt.multiformData[11].implementation = ''
              this.tabDataCrt.multiformData[11].reason = ''
            }
            api.hbEssentialInformationEnquiry({
              reportId: this.reportId
            }).then(res => {
              if (res.data) {
                this.tabDataCrt.multiformData[1].content = res.data.unitName
                this.tabDataCrt.multiformData[2].content = res.data.registeredAddress
                this.tabDataCrt.multiformData[3].content = res.data.postalCode
                this.tabDataCrt.multiformData[4].content = res.data.productionAddress
                this.tabDataCrt.multiformData[5].content = res.data.industryLevel
                this.tabDataCrt.multiformData[6].content = res.data.centerLongitude
                this.tabDataCrt.multiformData[7].content = res.data.centerDimension
                this.tabDataCrt.multiformData[8].content = res.data.organizationCode
                this.tabDataCrt.multiformData[9].content = res.data.socialCreditCode
                this.tabDataCrt.multiformData[10].content = res.data.technicalDirector
                this.tabDataCrt.multiformData[11].content = res.data.contactNumber
              } else {
                this.tabDataCrt.multiformData[1].content = ''
                this.tabDataCrt.multiformData[2].content = ''
                this.tabDataCrt.multiformData[3].content = ''
                this.tabDataCrt.multiformData[4].content = ''
                this.tabDataCrt.multiformData[5].content = ''
                this.tabDataCrt.multiformData[6].content = ''
                this.tabDataCrt.multiformData[7].content = ''
                this.tabDataCrt.multiformData[8].content = ''
                this.tabDataCrt.multiformData[9].content = ''
                this.tabDataCrt.multiformData[10].content = ''
                this.tabDataCrt.multiformData[11].content = ''
              }
            })
          })
        }
      }
    },
    handleRefresh () {
      console.log(this.tabType)
      this.tabDataCrt = this.tabData.filter((item) => { return item.tabIndex === this.tabType })[0]
      this.isRefresh = false
      this.$nextTick(function () {
        this.isRefresh = true
        this.pageNo = 1
        this.getTabData()
      })
    },
    table_index (index) {
      return (this.pageNo - 1) * this.pages + index + 1
    },
    handleCurrentChange (pageNo) {
      this.pageNo = pageNo
      this.getTabData(this.pageNo)
    },
    addRow () {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.add]({
          reportId: this.reportId,
          ...this.tabDataCrt.api.extraParam
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    editRow (row) {
      row.editFlag = true
    },
    saveRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        var savePusher = {
          id: row.id,
          ...this.tabDataCrt.api.extraParam
        }
        this.tabDataCrt.rowItems.forEach(rowItem => {
          console.log(row, rowItem, row[rowItem])
          savePusher[rowItem] = row[rowItem] || ''
        })
        api[this.tabDataCrt.api.update](savePusher).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    deleteRow (row) {
      if (this.tabDataCrt.tabType === 'table') {
        api[this.tabDataCrt.api.delete]({
          id: row.id
        }).then(res => {
          console.log(res)
          this.$nextTick(() => {
            this.isRefresh = true
            this.pageNo = 1
            this.getTabData()
          })
        })
      }
    },
    editForm () {
      this.tabDataCrt.editable = true
    },
    saveForm () {
      this.tabDataCrt.editable = false
      if (this.tabType === 'tabBA') {
        api.HbEnterpriseSituationAdd({
          reportId: this.reportId,
          changeOne: this.tabDataCrt.multiformData[1].implementation,
          remarksOne: this.tabDataCrt.multiformData[1].reason,
          changeTwo: this.tabDataCrt.multiformData[2].implementation,
          remarksTwo: this.tabDataCrt.multiformData[2].reason,
          changeThree: this.tabDataCrt.multiformData[3].implementation,
          remarksThree: this.tabDataCrt.multiformData[3].reason,
          changeFour: this.tabDataCrt.multiformData[4].implementation,
          remarksFour: this.tabDataCrt.multiformData[4].reason,
          changeFive: this.tabDataCrt.multiformData[5].implementation,
          remarksFive: this.tabDataCrt.multiformData[5].reason,
          changeSix: this.tabDataCrt.multiformData[6].implementation,
          remarksSix: this.tabDataCrt.multiformData[6].reason,
          changeSeven: this.tabDataCrt.multiformData[7].implementation,
          remarksSeven: this.tabDataCrt.multiformData[7].reason,
          changeEight: this.tabDataCrt.multiformData[8].implementation,
          remarksEight: this.tabDataCrt.multiformData[8].reason,
          changeNine: this.tabDataCrt.multiformData[9].implementation,
          remarksNine: this.tabDataCrt.multiformData[9].reason,
          changeTen: this.tabDataCrt.multiformData[10].implementation,
          remarksTen: this.tabDataCrt.multiformData[10].reason,
          changeEleven: this.tabDataCrt.multiformData[11].implementation,
          remarksEleven: this.tabDataCrt.multiformData[11].reason
        }).then(res => {
          console.log(res)
          api.hbEssentialInformationAdd({
            reportId: this.reportId,
            unitName: this.tabDataCrt.multiformData[1].content,
            registeredAddress: this.tabDataCrt.multiformData[2].content,
            postalCode: this.tabDataCrt.multiformData[3].content,
            productionAddress: this.tabDataCrt.multiformData[4].content,
            industryLevel: this.tabDataCrt.multiformData[5].content,
            centerLongitude: this.tabDataCrt.multiformData[6].content,
            centerDimension: this.tabDataCrt.multiformData[7].content,
            organizationCode: this.tabDataCrt.multiformData[8].content,
            socialCreditCode: this.tabDataCrt.multiformData[9].content,
            technicalDirector: this.tabDataCrt.multiformData[10].content,
            contactNumber: this.tabDataCrt.multiformData[11].content
          }).then(res => {
            console.log(res)
            this.$nextTick(function () {
              this.getTabData()
            })
          })
        })
      } else if (this.tabType === 'tabBB') {
        api.HbEnterpriseSituationAdd({
          reportId: this.reportId,
          changeTwenty: this.tabDataCrt.multiformData[1].implementation,
          remarksTwenty: this.tabDataCrt.multiformData[1].reason,
          changeTwentyOne: this.tabDataCrt.multiformData[2].implementation,
          remarksTwentyOne: this.tabDataCrt.multiformData[2].reason,
          changeTwentyTwo: this.tabDataCrt.multiformData[3].implementation,
          remarksTwentyTwo: this.tabDataCrt.multiformData[3].reason
        }).then(res => {
          console.log(res)
          api.hbEssentialInformationAdd({
            reportId: this.reportId,
            enterpriseNature: this.tabDataCrt.multiformData[1].content,
            pollutantUnit: this.tabDataCrt.multiformData[2].content,
            productionAudit: this.tabDataCrt.multiformData[3].content
          }).then(res => {
            console.log(res)
            this.$nextTick(function () {
              this.getTabData()
            })
          })
        })
      }
    }
    // makeSure (item) {
    //   if (this.tabType === '基本情况(概要信息)') {
    //     this.extaParam = {
    //       category: 1,
    //       ehsId: item.id
    //     }
    //   } else if (this.tabType === '基本情况(总量)') {
    //     this.extaParam = {
    //       category: 2,
    //       ehsId: item.id
    //     }
    //   } else if (this.tabType === '基本情况(环保证件)') {
    //     this.extaParam = {
    //       category: 3,
    //       ehsId: item.id
    //     }
    //   } else if (this.tabType === '主体工程(主要产品及产能)') {
    //     this.extaParam = {
    //       category: 4,
    //       ehsId: item.id
    //     }
    //   }
    //   this.importFlag = true
    // },
    // checkUpload () {
    //   this.$refs.uploadRef.doUpload()
    // },
    // checkUploadA () {
    //   this.$refs.uploadRefA.doUpload()
    // },
    // handleSuccess () {
    //   this.$toast.text('上传成功')
    //   this.importFlag = false
    //   this.importFlagA = false
    //   this.getTabData()
    // }
  },
  components: {
    // ehsTableImport
    // api,
    // showTableData () {
    //   return this.tableData
    // }
  }
}
</script>

<style lang="scss">
.homepage{
  width: 100%;
  div{
    border-radius: 2px;
  }
}
.mapwrap{
  z-index: 0;
  height: 100%;
  overflow: hidden;
}
.pollutionSrcsTabs{
  margin: 0 10px;
}
.searchInput{
  width: 50%;
  margin: 4px 10px;
  // padding-left: 10px;
  display: flex;
  font-size: 16px;
  .searchInput-prepend{
    font-weight: bold;
  }
  // margin-top: 0;
  // .searchInput div{
  //   height: 40px;
  //   // line-height: 40px;
  // }
  // .searchLabel{
  //   padding-top: 1px;
  //   height: 32px;
  //   font-size: 17px;
  // }
  // .el-input__icon{
  //   width: 20px!important;
  //   line-height: 28px!important;
  // }
}
.btnRefresh{
  margin: 0 10px 0 0!important;
}
.btnUpdate{
  margin: 0 0 0 10px!important;
  width: 120px!important;
}
.mainTable{
  margin: 10px;
  width: calc(100% - 20px);
  .tableFileCell{
    text-decoration: underline;
    color: #00C;
  }
  .tableFileCell:hover{
    color: #66F;
    text-decoration: none;
  }
  .cell{
    border: 1px #ccc solid;
    text-align: center;
  }
  .thtitle{
    background-color: #fafafa;
    line-height: 24px;
  }
  .tdcell{
    background-color: #fff;
    line-height: 32px;
    padding: 2px;
    .el-input__inner{
      height: 28px!important;
    }
  }
}
.bottom-pagination .el-pagination {
  text-align: right;
  margin-top: 6px;
  margin-bottom: 6px;
}

.el-card{
  margin-top: 4px;
  .el-card__header{
    padding: 0;
  }
  .el-card__body{
    padding: 0;
    overflow-y: auto;
  }
}
</style>
